import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp, faHistory } from "@fortawesome/free-solid-svg-icons";
import { getStatusStyles } from "../../../utils/attendanceHelpers";

const AttendanceTimelineTable = ({ data, pageNumber, pageSize, expandedRows, toggleRow, onRowClick }) => {
    return (
        <table className="w-full text-left border-collapse min-w-[900px]">
            <thead className="sticky top-0 z-10 bg-gray-50/95 backdrop-blur-sm shadow-sm">
                <tr className="text-[10px] font-black text-gray-400 uppercase tracking-widest border-b border-gray-200">
                    <th className="py-4 pl-6 pr-4 w-16">SR.NO</th>
                    <th className="py-4 px-4 w-28">EMP ID</th>
                    <th className="py-4 px-4 w-48">EMP NAME</th>
                    <th className="py-4 px-4 text-center">ATTENDANCE TRACK</th>
                    <th className="py-4 px-4 w-32">STATUS</th>
                    <th className="py-4 pr-6 pl-4 w-16 text-right"></th>
                </tr>
            </thead>
            <tbody className="text-sm">
                {data.map((row, idx) => {
                    const isExpanded = !!expandedRows[row.empId];
                    return (
                        <React.Fragment key={row.empId}>
                            <tr className={`border-b border-gray-100 hover:bg-gray-50/50 transition-colors ${isExpanded ? 'bg-indigo-50/30 hover:bg-indigo-50/30' : ''}`}>
                                <td className="py-4 pl-6 pr-4 font-bold text-gray-500 text-xs">{(pageNumber - 1) * pageSize + idx + 1}</td>
                                <td className="py-4 px-4 font-bold text-gray-400 text-xs">{row.empId}</td>
                                <td className="py-4 px-4 font-black text-[#1E293B]">{row.empName}</td>
                                <td className="py-4 px-4 max-w-sm xl:max-w-lg">
                                    <div className="flex flex-col items-center justify-center">
                                        <span className="text-[9px] font-bold text-gray-400 uppercase tracking-widest mb-1 self-start ml-1">DATE RANGE</span>
                                        <div className="flex flex-wrap items-center gap-1 w-full">
                                            {row.dateTrack.map((day, i) => (
                                                <div key={i} className="flex flex-col items-center gap-0.5">
                                                    <div className={`w-3 h-3 sm:w-3.5 sm:h-3 rounded-[2px] shadow-sm ${day.colorClass}`} title={day.date}></div>
                                                    {row.dateTrack.length <= 14 && (
                                                        <span className="text-[9px] font-bold text-gray-400">{day.label}</span>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </td>
                                <td className="py-4 px-4">
                                    <span className={`px-3 py-1 rounded-md text-[10px] font-black uppercase tracking-wider inline-block ${getStatusStyles(row.status).badge}`}>
                                        {row.status}
                                    </span>
                                </td>
                                <td className="py-4 pr-6 pl-4 text-right">
                                    <button
                                        onClick={() => toggleRow(row.empId)}
                                        className={`w-7 h-7 rounded-lg inline-flex items-center justify-center transition-all ${isExpanded ? 'bg-indigo-600 text-white' : 'bg-gray-100 text-gray-500 hover:bg-gray-200'}`}
                                    >
                                        <FontAwesomeIcon icon={isExpanded ? faChevronUp : faChevronDown} className="text-[10px]" />
                                    </button>
                                </td>
                            </tr>
                            {isExpanded && (
                                <tr>
                                    <td colSpan={6} className="p-0 border-b border-gray-200 bg-[#F8FAFC]">
                                        <div className="px-8 py-5 shadow-inner">
                                            <table className="w-full text-left text-[11px] border border-gray-200/60 rounded-lg overflow-hidden bg-white">
                                                <thead>
                                                    <tr className="text-[10px] font-black text-gray-400 uppercase tracking-widest border-b border-gray-200 bg-gray-50">
                                                        <th className="py-3 px-4 w-40">DATE</th>
                                                        <th className="py-3 px-4">CHECKIN</th>
                                                        <th className="py-3 px-4">CHECKOUT</th>
                                                        <th className="py-3 px-4">OT</th>
                                                        <th className="py-3 px-4">STATUS</th>
                                                        <th className="py-3 px-4">EARLY LEAVE</th>
                                                        <th className="py-3 px-4">ATTENDED</th>
                                                        <th className="py-3 px-4 text-right">LOG</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {row.records.map((rec, i) => (
                                                        <tr key={i} className="border-b border-gray-100 last:border-0 hover:bg-gray-50/50 transition-colors">
                                                            <td className="py-2.5 px-4">
                                                                <div className="flex flex-col">
                                                                    <span className="font-bold text-[#1E293B] text-xs">{rec.date}</span>
                                                                    <span className="text-[10px] font-semibold text-gray-400">{rec.dayOfWeek}</span>
                                                                </div>
                                                            </td>
                                                            <td className="py-2.5 px-4 font-semibold text-gray-600">{rec.checkIn}</td>
                                                            <td className="py-2.5 px-4 font-semibold text-gray-600">{rec.checkOut}</td>
                                                            <td className="py-2.5 px-4 font-semibold text-gray-600">{rec.ot}</td>
                                                            <td className="py-2.5 px-4">
                                                                <span className={`px-2.5 py-1 rounded-md text-[9px] font-black uppercase tracking-wider inline-block ${getStatusStyles(rec.status).badge}`}>
                                                                    {rec.status || "—"}
                                                                </span>
                                                            </td>
                                                            <td className="py-2.5 px-4 font-semibold text-gray-600">{rec.earlyLeaveMins > 0 ? `${rec.earlyLeaveMins} mins` : "—"}</td>
                                                            <td className="py-2.5 px-4 font-semibold text-gray-600">{rec.workHours}</td>
                                                            <td className="py-2.5 px-4 text-right">
                                                                <button
                                                                    onClick={() => onRowClick(rec, row.empName)}
                                                                    className="p-1.5 text-indigo-600 hover:bg-indigo-50 rounded-md transition-colors"
                                                                    title="View Timeline"
                                                                >
                                                                    <FontAwesomeIcon icon={faHistory} />
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </React.Fragment>
                    );
                })}
            </tbody>
        </table>
    );
};

export default AttendanceTimelineTable;
